import { siteContent } from "@/data/siteContent";

export const RecognitionSection = () => {
  const { recognition, patternBridge, observation } = siteContent;

  return (
  <section className="section-shell section-shell--paper" aria-labelledby="familiar-title" data-testid="recognition-section">
    <div className="site-container">
      <h2 id="familiar-title" className="section-title" data-testid="recognition-title">{recognition.heading}</h2>
      <p className="section-intro" data-testid="recognition-intro">
        {recognition.introduction.map((line) => <span className="copy-line" key={line}>{line}</span>)}
      </p>

      <div className="recognition-grid" data-testid="recognition-grid">
        {recognition.items.map((item, index) => (
          <article className="recognition-item" key={item.title} data-testid={`recognition-${item.title.toLowerCase().replaceAll(" ", "-")}-item`}>
            <span className="recognition-index" data-testid={`recognition-${item.title.toLowerCase().replaceAll(" ", "-")}-label`}>
              0{index + 1} / {item.title}
            </span>
            <h3 data-testid={`recognition-${item.title.toLowerCase().replaceAll(" ", "-")}-heading`}>{item.heading}</h3>
            <p data-testid={`recognition-${item.title.toLowerCase().replaceAll(" ", "-")}-copy`}>{item.copy}</p>
          </article>
        ))}
      </div>

      <div className="pattern-bridge" data-testid="pattern-bridge-section">
        <h2 className="pattern-bridge-title" data-testid="pattern-bridge-title">{patternBridge.heading}</h2>
        <div className="pattern-bridge-copy" data-testid="pattern-bridge-copy">
          {patternBridge.copy.map((line) => <p key={line}>{line}</p>)}
        </div>
      </div>

      <div className="real-section" data-testid="start-real-section">
        <div>
          <h2 className="real-statement" data-testid="start-real-title">{observation.heading}</h2>
        </div>
        <p className="real-copy" data-testid="start-real-copy">{observation.copy.map((line) => <span className="copy-line" key={line}>{line}</span>)}</p>
      </div>
    </div>
  </section>
  );
};